const stats = [
	{ value: '15+', label: 'Años de Experiencia', icon: 'Clock' },
	{ value: '2,500+', label: 'Análisis Realizados', icon: 'Flask' },
	{ value: '98%', label: 'Clientes Satisfechos', icon: 'Users' },
	{ value: '50+', label: 'Países Atendidos', icon: 'MapPin' },
];

export default stats;
